module.exports = __webpack_public_path__ + "static/media/avatar-cleaning.7c6628a2.png";